var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTextBox2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 576,
    height: 88,
    viewBox: "0 0 576 88",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-37.5 7.73433C-37.5 3.73892 -34.2611 0.5 -30.2657 0.5H568.266C572.261 0.5 575.5 3.73892 575.5 7.73433V58.9553C575.5 60.7855 574.806 62.5477 573.559 63.8868L563.528 74.6523L563.522 74.6592L553.23 85.2961C551.867 86.7047 549.991 87.5 548.031 87.5H-30.2657C-34.2611 87.5 -37.5 84.2611 -37.5 80.2657V7.73433Z",
    fill: "#1C223B",
    fillOpacity: 0.1,
    stroke: "url(#paint0_linear_36_1328)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_36_1328",
    x1: 269,
    y1: 0,
    x2: 269,
    y2: 88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0C528"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7C13A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextBox2);
export default __webpack_public_path__ + "static/media/textBox2.332e4b11bdc8c24d37b529efd340732a.svg";
export { ForwardRef as ReactComponent };